import React from 'react';
import PanoCloseButton from '../buttons/PanoCloseButton';

export default function PanoControls() {
    return (
        <div className="pano-control">
            <PanoCloseButton />
        </div>
    );
}
